
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/gmail",
      function () {
        return require("private-next-pages/android/local/gmail/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/gmail"])
      });
    }
  